// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  id: __t.u64().primaryKey(),
  userId: __t.u64().name("user_id"),
  seasonId: __t.u32().name("season_id"),
  currentXp: __t.u64().name("current_xp"),
  currentTier: __t.u32().name("current_tier"),
  isPremium: __t.bool().name("is_premium"),
  claimedFreeTiers: __t.string().name("claimed_free_tiers"),
  claimedPremiumTiers: __t.string().name("claimed_premium_tiers"),
});
